// export const PRODUCTION_BASE_URL = "http://141.136.42.247:5500/api/v1/"

// export const PRODUCTION_BASE_URL = "http://localhost:5500/api/v1/"
// export const PRODUCTION_BASE_URL = "https://ancient-beach-60604.herokuapp.com/api/v1/"

export const PRODUCTION_BASE_URL = "https://jposhserverendpointapi.onrender.com/api/v1/";

// checking for updates
// https://www.youtube.com/watch?v=oykl1Ih9pMg
// https://www.youtube.com/watch?v=X3Pr5VATOyA
// https://www.youtube.com/watch?v=jGHyaBpEn0g
